// extracted by mini-css-extract-plugin
export default {"name":"change-password_name__GsoR4","fields":"change-password_fields__kS3AO","field":"change-password_field__I3NYW"};